export default [
    {
        path: '/chanp/productManage',
        component: () => import( '@/views/chanp/productManage.vue'),
		meta: {
			title: '产品管理',
			isTabsPage: true,
			keepAlive: true
		}
	},
    {
        path: '/chanp/batchModifyManager',
        component: () => import( '@/views/chanp/batchModifyManager/index.vue'),
		meta: {
			title: '修改型号经理',
			isTabsPage: true,
			keepAlive: true
		}
	},
    {
        path: '/chanp/batchModifyManagerApprove',
        component: () => import( '@/views/chanp/batchModifyManager/approve.vue'),
		meta: {
			title: '修改型号经理审批'
		}
	},
    {
        path: '/chanp/productCreate',
        component: () => import( '@/views/chanp/productCreate.vue'),//
    },
	//
	{
        path: '/chanp/dateDelivery',
        component: () => import( '@/views/chanp/dateDelivery.vue'),
		meta: {
			title: '交货期维护',
			isTabsPage: true,
			keepAlive: true
		}
	},
	//��Ʒ��������
	{
		path: '/chanp/productManagerCenter',
        component: () => import( '@/views/chanp/productManagerCenter.vue'),
	},
	{
		path: '/chanp/productCreate3Q',
		component: () => import( '@/views/chanp/productCreate3Q.vue'),//
	},
	{
		path: '/chanp/priceOnlyRead',
		component: () => import( '@/views/chanp/priceOnlyRead.vue'),//
	},
	//历史定价
	{
		path: '/chanp/priceHistoric',
		component: () => import( '@/views/chanp/priceHistoric.vue'),//
	},
	{
		path: '/chanp/priceSetPass',
		component: () => import( '@/views/chanp/priceSetPass.vue'),//
	},
	{
	    path: '/chanp/productDetail',
	    component: () => import( '@/views/chanp/productDetail.vue'),//
	},
	{
	    path: '/chanp/salesTable',
	    component: () => import( '@/views/chanp/salesTable.vue'),//
		meta: {
			title: '销售样表',
			isTabsPage: true,

		}
	},
	{
		path: '/chanp/salesTableF',
		component: () => import( '@/views/chanp/salesTableF.vue'),//
		meta: {
			title: '销售样表（外）',
			isTabsPage: true,

		}
	},
	{
		path: '/chanp/salesTableSh',
		component: () => import( '@/views/chanp/salesTableSh.vue'),//
		meta: {
			title: '销售样表（上海直销）',
			isTabsPage: true,
			keepAlive: true
		}
	},
	{
		path: '/chanp/salesTableFw',
		component: () => import( '@/views/chanp/salesTableFw.vue'),//
		meta: {
			title: '销售样表（服务订单）',
			isTabsPage: true,

		}
	},
	{
	    path: '/chanp/salesTablebj',
	    component: () => import( '@/views/chanp/salesTablebj.vue'),//
	},
	{
		path: '/chanp/salesTableFbj',
		component: () => import( '@/views/chanp/salesTableFbj.vue'),//
	},
	{
		path: '/chanp/salesTableShbj',
		component: () => import( '@/views/chanp/salesTableShbj.vue'),//
	},
	{
		path: '/chanp/salesTableFwbj',
		component: () => import( '@/views/chanp/salesTableFwbj.vue'),//
	},
	{
	    path: '/chanp/salesTablehx',
	    component: () => import( '@/views/chanp/salesTablehx.vue'),//
	},
	{
		path: '/chanp/salesTableFhx',
		component: () => import( '@/views/chanp/salesTableFhx.vue'),//
	},
	{
		path: '/chanp/salesTableShhx',
		component: () => import( '@/views/chanp/salesTableShhx.vue'),//
	},
	{
		path: '/chanp/salesTableFwhx',
		component: () => import( '@/views/chanp/salesTableFwhx.vue'),//
	},
	{
	    path: '/chanp/priceManage',
	    component: () => import( '@/views/chanp/priceManage.vue'),
		meta: {keepAlive:true,title: '价格管理',
			isTabsPage: true
		}
	},
	{
		path: '/chanp/priceManage3Q',
		component: () => import( '@/views/chanp/priceManage3Q.vue'),
		meta: {keepAlive:true, title: '价格管理(3Q)',
			isTabsPage: true
		}
	},
	{
	    path: '/chanp/priceChange',
	    component: () => import( '@/views/chanp/priceChange.vue'),//
	},
	{
		path: '/chanp/ProductHierarchy',
		component: () => import( '@/views/chanp/ProductHierarchy.vue'),//
		meta: {
			title: '产品层级',
			isTabsPage: true,
			keepAlive: true
		}
  	},
	{
		path: '/chanp/productZhenshiwuliao',
		component: () => import( '@/views/chanp/productZhenshiwuliao.vue'),//
	},
	{
		path: '/chanp/productSourcing',
		component: () => import( '@/views/chanp/productSourcing.vue'),//
		meta: {
			title: '产品日报',
			isTabsPage: true,
			keepAlive: true
		}
	},
	{
		path: '/chanp/comparisonDetails',
		name: '/chanp/comparisonDetails',
		component: () => import( '@/views/chanp/comparisonDetails.vue'),//
	},
	{ //~{18;uILF7N,;$R3Cf~}
		path: '/chanp/commodityMaintenance',
		name: '/chanp/commodityMaintenance',
		component: () => import( '@/views/chanp/commodityMaintenance.vue'),//
		meta: {
			title: '备货商品维护',
			isTabsPage: true,
			keepAlive: true
		}
	},
	{ //共享大类维护
		path: '/chanp/shareModel',
		name: '/chanp/shareModel',
		component: () => import( '@/views/chanp/shareModel.vue'),//
		meta: {
			title: '共享产品',
			isTabsPage: true,
			keepAlive: true
		}
	},
	{ //用户大类维护
		path: '/chanp/eanNotifyUser',
		name: '/chanp/eanNotifyUser',
		component: () => import( '@/views/chanp/eanNotifyUser.vue'),//
		meta: {
			title: '用户对应大类维护',
			isTabsPage: true,
			keepAlive: true
		}
	},

	{
		path: '/chanp/productBom',
		component: () => import( '@/views/chanp/productBom.vue'),
		meta: {
			title: '套餐管理',
			isTabsPage: true,
			keepAlive: false
		}
	},
	{
		path: '/chanp/bomCreate',
		component: () => import( '@/views/chanp/bomCreate.vue'),//
	},
	{
		path: '/chanp/bomUpdate',
		component: () => import( '@/views/chanp/bomUpdate.vue'),//
	},
	{
		path: '/chanp/bomShenpi',
		component: () => import( '@/views/chanp/bomShenpi.vue'),//
	},
	{
		path: '/chanp/bomPackageScene',
		component: () => import( '@/views/chanp/bomPackageScene.vue'),//
		meta: {
			title: '套餐场景',
			isTabsPage: true,
			keepAlive: true
		}
	},
	{
		path: '/chanp/salesPackage',
		component: () => import( '@/views/chanp/salesPackage.vue'),
		meta: {
			title: '销售样表(套餐)',
			isTabsPage: true,
			keepAlive: true
		}
	},

	{
		path: '/chanp/companyPriceManage',
		component: () => import( '@/views/chanp/companyPriceManage.vue'),
		meta: {
			title: '价格管理(客户)',
			isTabsPage: true
		}
	},

	{
		path: '/chanp/createCompanyPrice',
		component: () => import( '@/views/chanp/createCompanyPrice.vue'),//
	},
	{
		path: '/chanp/companyPriceSetPass',
		component: () => import( '@/views/chanp/companyPriceSetPass.vue'),//
	},

	{
		path: '/chanp/companyPriceOnlyRead',
		component: () => import( '@/views/chanp/companyPriceOnlyRead.vue'),//
	},

	//产品管制页面
	{
		path: '/control/bscproductcontrol',
		component: () => import( '@/views/dingd/control/bscproductcontrol.vue'),//
		meta: {
			title: '产品管控',
			isTabsPage: true,
			keepAlive: true
		}
	},

	//订单ODT
	{
		path: '/control/bscOrderMainOtd',
		component: () => import( '@/views/dingd/productotd/bscOrderMainOtd.vue'),//
		meta: {
			title: '订单OTD报表',
			isTabsPage: true,
			keepAlive: true
		}
	},
	//售后签收确认列表
	{
		path: '/bscAfterSalesConfirm',
		component: () => import( '@/views/dingd/aftersalesconfirm/bscAfterSalesConfirm.vue'),//
		meta: {
			title: '售后工单报表',
			isTabsPage: true,
			keepAlive: true
		}
	},
	{
		path: '/chanp/revenueSatisticsList',
		component: ()=> import('@/views/chanp/revenueSatisticsList.vue'),
		meta:{
			title: '元析收入报表',
			isTabsPage: true,
			keepAlive: true
		}
	},
	{
		path: '/chanp/revenueSatisticsPersonalList',
		component: ()=> import('@/views/chanp/revenueSatisticsPersonalList.vue'),
		meta:{
			title: '元析个人收入报表',
			isTabsPage: true,
			keepAlive: true
		}
	},
	//促销产品
	{
		path: '/salesPromotionList',
		component: () => import( '@/views/chanp/salesPromotion/index.vue'),//
		meta: {
			title: '促销活动管理',
			isTabsPage: true,
			keepAlive: true
		}
	},
	{
		path: '/salesPromotionList/addNewActivites',
		component: () => import( '@/views/chanp/salesPromotion/addNewActivites.vue'),//
	},
	{
		path: '/salesPromotionList/seeActivites',
		component: () => import( '@/views/chanp/salesPromotion/seeActivites.vue'),//
	},
	{
		path: '/chanp/salesTableShp',
		component: () => import( '@/views/chanp/salesTableExpendShp.vue'),//
	},
	{
		path: '/chanp/salesTableReSubmit',
		component: () => import( '@/views/chanp/salesTableReSubmit.vue'),//
	},
	//公司间服务产品对照
	{
		path: '/chanp/fwMaterialCompare',
		component: () => import( '@/views/chanp/materialCompare/fwMaterialCompare.vue'),//
		meta:{
			title: '公司间服务产品对照',
			isTabsPage: true,
			keepAlive: true
		}
	},

	{
		path: '/orderXietong/bscOrderXietong',
		component: () => import( '@/views/loud/orderXietong/bscOrderXietong.vue'),
		meta: {
			title: '是否协同管理',
			isTabsPage: true,
			keepAlive:true
		}
	},
	{
		path: '/orderXietong/bscOrderXietongSp',
		component: () => import( '@/views/loud/orderXietong/xietongSp.vue'),
		meta: {
			title: '是否协同管理审批',
			isTabsPage: false,
			keepAlive:false
		}
	},
]
